import loadable from '@loadable/component';

export const namespace = 'canalplus.block.selfcare.out_package';
export const Component = loadable(
  () => import('./containers/OutPackageContainer')
);

export { default as propsFormatter } from './propsFormatter';
